var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-layout type-profile"},[_c('main-navbar'),_c('div',{staticClass:"wrapper",class:[{ 'nav-open': _vm.$sidebar.showSidebar }],on:{"click":_vm.closeArea}},[_c('notifications'),_c('side-bar',{attrs:{"mini":true,"active-color":_vm.sidebarBackground,"background-image":_vm.sidebarBackgroundImage,"data-background-color":_vm.sidebarBackgroundColor}},[_c('template',{slot:"links"},[_c('div',{staticClass:"profiles"},[(!_vm.isAcademic)?_c('sidebar-item',{staticClass:"sidebar-item-plus",attrs:{"link":{
              name: 'Prospect Search',
              icon: 'source',
              path: '/prospect-search',
            }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
              name: 'Industry Financial',
              icon: 'card_travel',
              path: '/new-profile/industry-financial-profile',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Industry Market',
              icon: 'leaderboard',
              path: '/new-profile/industry-market-profile',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Companies',
              icon: 'business',
              path: '/company-search',
            }}}),(!_vm.isAcademic)?_c('div',{staticClass:"disable"},[_c('sidebar-item',{attrs:{"link":{
                name: 'Market',
                icon: 'insights',
                path: '/',
              }}}),_c('sidebar-item',{attrs:{"link":{
                name: 'Franchise',
                icon: 'store',
                path: '/',
              }}})],1):_vm._e(),(!_vm.isAcademic)?_c('sidebar-item',{attrs:{"link":{
              name: 'Valuation Multiple',
              icon: 'addchart',
              path: '/valuation-multiple',
            }}}):_vm._e(),(!_vm.isAcademic)?_c('sidebar-item',{attrs:{"link":{
              name: 'Financial Report',
              icon: 'text_snippet',
              path: '/create-report-format/financial',
            }}}):_vm._e(),(!_vm.isAcademic)?_c('sidebar-item',{attrs:{"link":{
              name: 'Market Report',
              icon: 'newspaper',
              path: '/create-report-format/market',
            }}}):_vm._e(),(!_vm.isAcademic)?_c('sidebar-item',{attrs:{"link":{
              name: 'Valuation Report',
              icon: 'request_quote',
              path: '/create-report-format/valuation',
            }}}):_vm._e(),(!_vm.isAcademic)?_c('sidebar-item',{attrs:{"link":{
              name: 'Company Report',
              icon: 'summarize',
              path: '/create-report-format/company',
            }}}):_vm._e()],1),(!_vm.isAcademic)?_c('div',{staticClass:"section_wpr"},[_vm._v("My Data")]):_vm._e(),_c('div',{staticClass:"profiles border-0"},[(!_vm.isAcademic)?_c('sidebar-item',{attrs:{"link":{
              name: 'Prospect List',
              icon: 'format_list_bulleted',
              path: '/my-prospect-lists',
            }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
              name: 'Profiles',
              icon: 'folder_open',
              path: '/my-profiles',
            }}}),(!_vm.isAcademic)?_c('sidebar-item',{attrs:{"link":{
              name: 'Reports',
              icon: 'description',
              path: '/my-reports',
            }}}):_vm._e(),(!_vm.isAcademic)?_c('sidebar-item',{attrs:{"link":{
              name: 'Data',
              icon: 'dns',
              path: '/my-data',
            }}}):_vm._e()],1)])],2),_c('app-side-bar',{attrs:{"mini":true,"active-color":_vm.sidebarBackground,"background-image":_vm.sidebarBackgroundImage,"data-background-color":_vm.sidebarBackgroundColor}},[_c('mobile-menu'),_c('template',{slot:"links"},[_c('div',{staticClass:"search_panel lft-prfl-bar"},[_c('ul',{staticClass:"filter_list prfl-cmpany-bar"},[_c('sidebar-item',{attrs:{"link":{
                name: 'About',
                icon: 'help',
                path: ("/companies/" + _vm.profileInfoId + "/company-about-the-data"),
                type: 'product',
              }}}),_c('sidebar-item',{class:_vm.profileInfo || !_vm.loading ? '' : 'disabled-item',attrs:{"link":{
                name: 'Company Details',
                icon: 'info',
                path: ("/companies/" + _vm.profileInfoId + "/profile"),
                type: 'product',
              }}}),_c('sidebar-item',{class:_vm.profileInfo || !_vm.loading ? '' : 'disabled-item',attrs:{"link":{
                name: 'Bizminer Insights',
                icon: 'developer_board',
                path: ("/companies/" + _vm.profileInfoId + "/financial-insights"),
                type: 'product',
              }}})],1)])])],2),_c('div',{staticClass:"main-panel"},[_c('div',{class:{ content: !_vm.$route.meta.hideContent }},[(!_vm.isAboutRoute)?_c('div',{staticClass:"content"},[_c('PulseLoader',{class:{ hide: !_vm.loading },attrs:{"loading":_vm.loading,"quote":"Action is the foundational key to all success","author":"Pablo Picasso","profession":"Spanish Painter","img":"picasso.jpg"}})],1):_vm._e(),_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('div',{staticClass:"row"},[(!_vm.loading || _vm.isAboutRoute)?_c('router-view',{attrs:{"headerData":_vm.headerData}}):_vm._e()],1)])],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }